import { Components, Theme } from "@mui/material";

const MuiTypography: Components<Theme>["MuiTypography"] = {
  styleOverrides: {
    root: {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
    },
  },
};

export default MuiTypography;
